module.exports = __webpack_public_path__ + "static/img/rules.c4cf247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/signup/rules.png
// module id = H+t8
// module chunks = 0